require('es6-promise').polyfill();
require('whatwg-fetch');
if (process.env.NODE_ENV !== 'production') require('event-source-polyfill');



// WEBPACK FOOTER //
// ./polyfill.js